export enum SystemRoleDTO {
	ADMIN = 'ADMIN',
	TAC = 'TAC',
	MC = 'MC',
	ES = 'ES',
	EXPERT = 'Expert',
	BOARD_MEMBER = 'Board member',
	DIRECTOR = 'Director',
}
